import tokens from './tokens'
import { FarmConfig } from './types'

const farms: FarmConfig[] = [
  /**
   * These 2 farms (PID 0, 1) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'WOLF',
    lpAddresses: {
      41: '0xdcddF4dc462F036445BA3fF19F7df91436bA4669',
    },
    token: tokens.syrup,
    quoteToken: tokens.wtlos,
  },
  {
    pid: 1,
    lpSymbol: 'WOLF-TLOS LP',
    lpAddresses: {
      41: '0x2Bc311341E98cb34f83f14CC99EBaa89B4781bB7',
    },
    token: tokens.cake,
    quoteToken: tokens.wtlos,
  },
  {
    pid: 2,
    lpSymbol: 'FIAT-SOON LP',
    lpAddresses: {
      41: '0x25e51919891a10506527a6a610451C4eC1eC6F06',
    },
    token: tokens.fiat,
    quoteToken: tokens.soon,
  },
  {
    pid: 3,
    lpSymbol: 'SOON-WOLF LP',
    lpAddresses: {
      41: '0x48Ed0b1F7072e5182915808aDBE968bD00a84fA6',
    },
    token: tokens.soon,
    quoteToken: tokens.cake,
  },
  {
    pid: 4,
    lpSymbol: 'SOON-TLOS LP',
    lpAddresses: {
      41: '0x7ec834A646343862F5D8ADbED020116cA28e0bc2',
    },
    token: tokens.soon,
    quoteToken: tokens.wtlos,
  },
  {
    pid: 5,
    lpSymbol: 'FIAT-TLOS LP',
    lpAddresses: {
      41: '0x273F1d07dD525dA71F532e3c55214143B91C9d83',
    },
    token: tokens.fiat,
    quoteToken: tokens.wtlos,
  },
]

export default farms
